/* 
-----------------------------------------------------------------------------
| DATE SELECTION PAGE
-----------------------------------------------------------------------------
- description: its only purpose is to manage the value of booking.date
  and reset other values or navigate to other route if needed
*/
import { useState, useEffect, useRef, useContext } from "react";
import { DateSelector } from "../parts/date-selector/DateSelector";
import { AppContext } from "../App";
import { getWeekSlotsTillMonthEnd } from "../utils/helpers";
import { SHOW_DATE_CELLS_BEFORE_MONTH_START } from "../utils/symbols";

export const DateSelection = (props) => {
	// todo: move availability to provider to not loose the cache when changing step
	const [dateSelected, setDateSelected] = useState(null);
	const [availability, setAvailability] = useState([]);
	const requestedMonths = useRef({});
	// MonthsAvailability keys -> yyyy-m with january as 1
	const { data, setData, setIsTransitioning } = useContext(AppContext);
	const { loading, setLoading } = props;

	const handleDateSelection = (date) => {
		setIsTransitioning(false);
		setDateSelected(date);
		setTimeout(() => {
			setData({ ...data, date });
		}, 200);
	};

	const getMonthAvailability = async (dt) => {
		const date = new Date(dt);
		if (
			requestedMonths.current[
				`${date.getFullYear()}-${date.getMonth() + 1}`
			]
		)
			return;
		requestedMonths.current[
			`${date.getFullYear()}-${date.getMonth() + 1}`
		] = true;
	};

	useEffect(() => {
		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
		setLoading(true);

		let controller = new AbortController();
		let options = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
			signal: controller.signal,
		};

		fetch(
			`${API_URL}/availability/by-day/${data.centerCode}?locator=${data.locator}`,
			options
		)
			.then((res) => res.json())
			.then((newData) => {
				if (newData.result === "ok") {
					setAvailability(newData.days);
				}
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				setLoading(false);
				controller.abort();
			});
	}, [data.centerCode, data.locator, setLoading]);

	const now = new Date();
	// const now = new Date("2025-05-26");
	const weekSlotsTillMonthEnd = getWeekSlotsTillMonthEnd(now);
	const start =
		weekSlotsTillMonthEnd === 1 && SHOW_DATE_CELLS_BEFORE_MONTH_START
			? new Date(now.getFullYear(), now.getMonth() + 1, 1)
			: now.setDate(1);

	return (
		<main id="date-selection-page">
			{loading ? (
				<div className="loader">
					<div className="spinner"></div>
				</div>
			) : (
				<DateSelector
					displayedMonthsQty={12 - new Date().getMonth()}
					from={start}
					at={start}
					value={dateSelected}
					monthsAvailability={availability}
					onDateSelected={handleDateSelection}
					onMonthChange={getMonthAvailability}
				/>
			)}
		</main>
	);
};
